import { UsuariosPlataformaService } from "../../../shared/generated/grpc/plataforma_seguridad_usuarios_plataforma_pb";
import { ServiceDeleteBase } from "../../../shared/services/base/ServiceDeleteBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { UsuarioPlataformaService } from "./UsuarioPlataformaService";

/** Baja de usuarios de Plataforma; la saca del listado en memoria. */
export class UsuarioPlataformaDeleteService extends ServiceDeleteBase {
  protected readonly cache = UsuarioPlataformaService.instance;

  /** gRPC-Web (`Eliminar`): baja lógica y cierre de sus sesiones; idempotente. */
  protected async sendDelete(id: string): Promise<void> {
    await grpcCall(() => grpcClient(UsuariosPlataformaService).eliminar({ id }));
  }
}
